import { TAG_MODEL_KEY } from 'models/daos/tag/constants'
import { MODEL_KEY } from 'modules/redux/constants/model-key.js'
import getValueReduxUtil from 'modules/redux/utils/get-value'

const POSTER_TAGS_TO_AVOID = [
  'video',
  'meme',
  'recipe',
  'memes',
  'article',
  'poll',
  'gif',
  'iamagymaholic',
  'merch',
  'nutrition',
  'fact',
  'apparel',
  'infographic',
  'routine',
  'giveaway',
  'fitmas',
  'sax',
  'saxofficial',
  'triathlon',
  'app',
  'feature',
  'video',
  'video'
]

export default function canBeAPosterMotivationUtil (instance) {
  const tags = getValueReduxUtil(instance, 'tags') || []
  if (!tags.length) {
    return false
  }

  let isTextOrQuote
  const canBeAPoster = !tags.find(
    tagInstance => {
      const tagName = getValueReduxUtil(tagInstance, TAG_MODEL_KEY.NAME)
      if (tagName.includes('text') || tagName.includes('quote')) {
        isTextOrQuote = true
        return true
      }

      return tagName
        .split(' ')
        .find(tagWord => POSTER_TAGS_TO_AVOID.includes(tagWord))
    }
  )

  if (isTextOrQuote) {
    return true
  }

  if (!canBeAPoster) {
    return canBeAPoster
  }

  const createdAt = getValueReduxUtil(instance, MODEL_KEY.CREATED_AT)
  const createdAtDate = new Date(createdAt)
  const nonCopyrightedPhotosStartDate = new Date('2019-01-19')
  return (
    createdAtDate.getTime() >= nonCopyrightedPhotosStartDate.getTime()
  )
}
